import * as dayjs from 'dayjs';

export function fetchTodayDate(): string {
  const date = dayjs();
  return date.format('YYYY-MM-DD');
}
